import * as _ from 'lodash-es';
import React from 'react';
import Badge from '../../components/Badge';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';

const USER_FRAGMENT = gql(`
  # eslint-disable-next-line @graphql-eslint/require-selections
  fragment UserBadge_user on User {
    deactivatedAt
    importedFrom
    type
  }
`);

interface UserBadgeProps {
  user: DocumentType<typeof USER_FRAGMENT>;
  inline?: boolean;
}

export const userBadgeColors = {
  ADMIN: 'blue',
  DEACTIVATED: 'gray',
  GUEST: 'yellow',
  IMPORTED: 'gray',
  INVITED: 'gray',
  BOT: 'pink',
  VISITOR: 'gray',
} as const;

const UserBadge = ({
  user: { deactivatedAt, type, importedFrom },
  inline,
}: UserBadgeProps) => {
  if (importedFrom) {
    return (
      <Badge color={userBadgeColors.IMPORTED} inline={inline}>
        Imported
      </Badge>
    );
  }
  if (deactivatedAt) {
    return (
      <Badge color={userBadgeColors.DEACTIVATED} inline={inline}>
        Deactivated
      </Badge>
    );
  }
  if (type && type !== 'USER') {
    return (
      <Badge color={userBadgeColors[type]} inline={inline}>
        {_.capitalize(type)}
      </Badge>
    );
  }

  return null;
};

export default UserBadge;
